import { render } from "./StrategyDetails.vue?vue&type=template&id=5bf5e190"
import script from "./_StrategyDetails.js?vue&type=script&lang=js&external"
export * from "./_StrategyDetails.js?vue&type=script&lang=js&external"

import "./_StrategyDetails.less?vue&type=style&index=0&lang=less&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__